import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';

export default function AdminLayout({ userEmail }: { userEmail: string }) {
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar userEmail={userEmail} />
      <main style={{
        marginLeft: 'var(--sidebar-width)',
        flex: 1,
        overflow: 'auto',
        padding: '28px 32px',
        minHeight: '100vh',
      }}>
        <Outlet />
      </main>
    </div>
  );
}
